(function (window) {
  'use strict';

  var MONTHS = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
  var EXPIRY_PATTERN = /(?:venc(?:imento)?|validade)\s*[\.\-:]?\s*(\d{1,2})\s*[\/\-]\s*(\d{2,4})\b/i;

  function format(month, year) {
    var monthIndex = parseInt(month, 10) - 1;
    if (monthIndex < 0 || monthIndex > 11) return null;

    var yearStr = String(year);
    if (yearStr.length === 2) {
      yearStr = '20' + yearStr;
    }

    return 'Vencimento ' + MONTHS[monthIndex] + '/' + yearStr;
  }

  function cleanTitle(title) {
    if (!title) return '';

    return String(title)
      .replace(EXPIRY_PATTERN, '')
      .replace(/\s*-\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parse(title) {
    if (!title) return null;

    var match = String(title).match(EXPIRY_PATTERN);
    if (!match) return null;

    var month = parseInt(match[1], 10);
    var year = match[2];
    var label = format(month, year);

    if (!label) return null;

    return {
      month: month,
      year: year,
      label: label,
      cleanTitle: cleanTitle(title)
    };
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildBadgeHtml(label) {
    if (!label) return '';

    return '<span class="product-expiry-tag">' + escapeHtml(label) + '</span>';
  }

  window.FlorenzaProductExpiry = {
    MONTHS: MONTHS,
    EXPIRY_PATTERN: EXPIRY_PATTERN,
    parse: parse,
    format: format,
    cleanTitle: cleanTitle,
    buildBadgeHtml: buildBadgeHtml
  };
})(window);
